import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PhonesPhoto from '../../assets/images/iPhone_with_Places.png'; // Update with your actual path

const Contact = () => {
    return (
        <Box
            sx={{
                p: { xs: 4, sm: 15 },
            }}
        >
            <Stack
                direction={{ xs: 'column', sm: 'row-reverse' }} // Reverse row for text on the right
                alignItems="center"
                spacing={4}
                sx={{
                    justifyContent: 'space-between',
                    flexWrap: 'wrap', // Ensure proper wrapping for smaller screens
                }}
            >
                {/* Text Content */}
                <Box
                    sx={{
                        flex: 1,
                        textAlign: { xs: 'left', sm: 'left' }, // Center for mobile, left for desktop
                        maxWidth: { sm: '40%' },
                    }}
                >
                    {/* Phase 1 */}
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 500,
                            color: '#dc5454',
                            fontSize: { xs: '1.2rem', sm: '2rem' },
                            mb: 2,
                        }}
                    >
                        Contact Us
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "justify",
                            fontSize: { xs: '1rem', sm: '1.15rem' },
                            maxWidth: { xs: '100%', sm: '75%' },
                            mb: 4,
                        }}
                    >
                        For business inquiries, partnerships and more, please reach out to us at{' '}
                        <a href="mailto:David@travyx.com">david@travyx.com</a>.
                        <br />
                        For customer support, visit our website and head to the "Contact Us" section, or simply email us at{' '}
                        <a href="mailto:info@travyx.com">info@travyx.com</a>.
                    </Typography>


                </Box>

                {/* PNG Image */}
                <Box
                    component="img"
                    src={PhonesPhoto}
                    alt="Illustration"
                    draggable="false"
                    sx={{
                        flex: 1,
                        width: { xs: '100%', sm: '60%' }, // 85% width on mobile, 50% width on desktop
                        maxWidth: '620px',
                    }}
                />
            </Stack>
        </Box>
    );
};

export default Contact;
